import React from 'react';

import "../App.css";
const Landing = () => {
    return (

        <div className="landing">
            <div className="landing-content">
                <h1>We Mount TVs</h1>
                <p>Providing tv mounting, wire hiding and other mounting related services around DFW area!</p>
                <p> Please Call us today to book your service!</p>

                <div className="desktop-view">
                    <a herf="#">682-292-8560</a>

                </div>


                <div className="mobile-view">
                    <a href="tel:6822928560" > Call 682-292-8560</a>
                </div>

            </div>
            <img src="/m.jpeg" alt="cartoon" />
        </div>




    );
}

export default Landing;